import React from 'react';
import { AppBar, Toolbar, ThemeProvider,  Tab, Tabs, useTheme } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';

const Navbar: React.FC = () => {
  const location = useLocation();
  const theme = useTheme();

  const getValue = (path: string) => {
    if (path === '/') return 0;
    if (path === '/balingPage') return 1;
    if (path === '/uiucPage') return 2;
    return false;
  };

  const value = getValue(location.pathname);

  return (
    <AppBar position="absolute" sx={{ 
      background: 'transparent',
      boxShadow: 'none',
      position: 'absolute',
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
                    color: theme.palette.primary.light,

      justifyContent: 'center'}}>
        <ThemeProvider theme={theme}>
      <Toolbar sx={{
        display: 'flex',
                      color: theme.palette.primary.light,

        justifyContent: 'space-between',
        width: "100%"
      }}>
        <Tabs value={value}
          role="navigation"
          sx={{
            '& .MuiTabs-indicator': {
              backgroundColor: theme.palette.primary.light,
            },
            '& .MuiTab-root': {
              color: theme.palette.primary.light,
              '&.Mui-selected': {
                color: theme.palette.primary.light,
              },
            },
          }}>
          <Tab label="HomePage" component={Link} to="/" />
          <Tab label="Farm Life" component={Link} to="/balingPage" />
          <Tab label="UIUC" component={Link} to="/uiucPage" />
        </Tabs>
      </Toolbar>
      </ThemeProvider>
    </AppBar>
  );
};

export default Navbar;
